import {useEffect} from 'react';
import {withParams} from "../../App";
import PageComponent from "../pageComponent/pageComponent";
import {useTensorflowDataStore} from "../../store/tensorflowDataStore";
import {getTopicPages} from "./pageDataHelpers";

// Rendered when the current slug isn't found in the data (or while data
// hasn't loaded yet) so the page still has something sensible to show
// instead of throwing on undefined fields.
const DEFAULT_ENTRY = {
    title: 'TensorFlow',
    tags: [], sourceLinks: [], languages: [], algos: [], attributed: [],
    source: '', dataFile: '', download: ''
};

const DEFAULT_NEXT = {key: '', slug: '', title: 'Machine Learning', path: '/machine-learning/tutorials/tensorflow/'};

export const TFPage = ({params}) => {
    // useTensorflowDataStore fetches /data/tensorflowData.json once (cached
    // in memory + localStorage) — see src/store/createDataStore.js.
    const {slugs, nextPage, relatedPages, suggestedCourses, isLoaded, loadData} = useTensorflowDataStore();

    useEffect(() => {
        loadData();
    }, [loadData]);

    if (!isLoaded) {
        return <div>Loading…</div>;
    }

    const slug = params?.slug || window.location.pathname.split('/').filter(Boolean).slice(-1)[0] || '';

    const found = slugs.find(item => item.slug === slug);
    if (!found) {
        console.error('TFPage Failed to locate HTML path for slug : ' + slug);
    }
    const current = found || DEFAULT_ENTRY;

    const next = nextPage.find(item => item.key === slug);
    const related = relatedPages.filter(item => item.key === slug);
    const suggested = suggestedCourses.filter(item => item.key === slug);
    const topicPages = getTopicPages(slugs, current, slug);

    const state = {
        nextContent: next || DEFAULT_NEXT,
        relatedContent: related,
        topicPages,
        title: current.title,
        tags: current.tags,
        sourceLinks: current.sourceLinks,
        languages: current.languages,
        algos: current.algos ?? [],
        suggestedCourses: suggested,
        attributed: current.attributed,
        source: current.source,
        html: '',
        dataFile: current.dataFile,
        download: current.download
    };

    return (
        <PageComponent props={state} page="Tensorflow Page"/>
    );
};

export default withParams(TFPage);
